import { useNavigation } from "@react-navigation/native";
import { useCallback, useEffect } from "react";

import { Button, Col1 } from "../lib";
import { createStyles, sizes } from "../theme";
import { browser } from "../services";
import { InstallScreen } from "./install";

export function AuthScreen() {
  // Vars
  const navigation = useNavigation();

  // Handlers
  const goToLogin = useCallback(() => {
    navigation.navigate("Login");
  }, [navigation]);

  const goToRegister = useCallback(() => {
    navigation.navigate("Register");
  }, [navigation]);

  // Effects
  useEffect(() => {
    navigation.setOptions({
      title: browser.installed ? "Welcome to Smooci" : "Install Smooci",
    });
  }, [navigation]);

  // Render
  if (!browser.installed) {
    return <InstallScreen />;
  }

  return (
    <Col1.LRB p="8" style={$.container}>
      <Button onPress={goToLogin}>Log in</Button>
      <Button em onPress={goToRegister}>
        Create account
      </Button>
    </Col1.LRB>
  );
}

const $ = createStyles({
  container: {
    gap: sizes["4"],
  },
});
